<template>
  <MaterialCard
    v-if="tankType != null"
    color="green"
    :style="`position: sticky; top: ${offsetTop}px; z-index: 10;`"
    full-width
  >
    <v-form
      v-model="ok"
    >
      <v-container py-0>
        <v-layout wrap>
          <v-flex
            xs6
          >
            <v-text-field
              class="purple-input"
              label="ID"
              readonly
              :value="id"
            />
          </v-flex>
          <v-flex
            xs6
          >
            <v-text-field
              v-model.trim="tankTypeCode"
              :readonly="readonly"
              class="purple-input"
              label="タンクタイプコード"
              :rules="[
                rules.required,
                v => isUniqueCode(v) || 'タンクタイプコードが重複しています'
              ]"
            />
          </v-flex>
          <v-flex
            xs12
          >
            <v-text-field
              v-model.trim="tankName"
              :readonly="readonly"
              class="purple-input"
              label="タンク名"
              :rules="[rules.required]"
            />
          </v-flex>
          <v-flex
            xs12
          >
            <v-text-field
              v-model.trim="makerName"
              :readonly="readonly"
              class="purple-input"
              label="メーカー名"
              :rules="[rules.required]"
            />
          </v-flex>
          <v-flex
            xs4
          >
            <NumberField
              v-model.number="oilMaxVolume"
              :readonly="readonly"
              :rules="['required']"
              class="purple-input"
              label="最大容量"
            />
          </v-flex>
          <v-flex
            xs4
          >
            <NumberField
              v-model.number="tankMaxVolume"
              :readonly="readonly"
              :rules="['required']"
              class="purple-input"
              label="法定容量"
            />
          </v-flex>
          <v-flex
            v-if="!readonly"
            xs4
          >
            <NumberField
              v-model.number="oilVolumeRate"
              :readonly="readonly"
              :rules="['required']"
              class="purple-input"
              label="オイル係数"
            />
          </v-flex>
          <v-flex
            xs4
          >
            <NumberField
              v-model.number="tankWidth"
              :readonly="readonly"
              :rules="['required']"
              class="purple-input"
              label="幅"
            />
          </v-flex>
          <v-flex
            xs4
          >
            <NumberField
              v-model.number="tankDepth"
              :readonly="readonly"
              :rules="['required']"
              class="purple-input"
              label="奥行き"
            />
          </v-flex>
          <v-flex
            xs4
          >
            <NumberField
              v-model.number="tankHeight"
              :readonly="readonly"
              :rules="['required']"
              class="purple-input"
              label="高さ"
            />
          </v-flex>
          <v-flex xs12>
            <v-textarea
              v-model.trim="remarks"
              :readonly="readonly"
              class="purple-input"
              label="備考"
            />
          </v-flex>
          <v-flex xs3>
            <v-btn
              v-if="!readonly"
              color="success"
              :disabled="!ok || !dirty"
              @click="onRegister"
            >
              {{ id === 'new'?'追加':'更新' }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </MaterialCard>
</template>

<script>
import { mapState } from 'vuex'
import { NumberField } from '@/components/input'

export default {
  components: {
    NumberField
  },
  props: {
    tankType: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      ok: false,
      rules: {
        required: v => !!v || '必須項目です。'
      },
      id: null,
      tankTypeCode: null,
      tankName: null,
      makerName: null,
      oilMaxVolume: null,
      tankMaxVolume: null,
      oilVolumeRate: null,
      tankWidth: null,
      tankDepth: null,
      tankHeight: null,
      remarks: ''
    }
  },
  computed: {
    ...mapState('display', ['offsetTop']),
    ...mapState('tankTypes', ['tankTypes']),
    dirty () {
      if (!this.tankType) return false
      return !props.every(prop => this.tankType[prop] === this[prop])
    }
  },
  watch: {
    tankType (value) {
      props.forEach(prop => { this[prop] = value[prop] })
    }
  },
  mounted () {
    props.forEach(prop => { this[prop] = this.tankType[prop] })
  },
  methods: {
    onRegister () {
      this.$emit('register', {
        id: this.id,
        tankTypeCode: this.tankTypeCode,
        tankName: this.tankName,
        makerName: this.makerName,
        oilMaxVolume: this.oilMaxVolume,
        tankMaxVolume: this.tankMaxVolume,
        oilVolumeRate: this.oilVolumeRate,
        tankWidth: this.tankWidth,
        tankDepth: this.tankDepth,
        tankHeight: this.tankHeight,
        remarks: this.remarks || ''
      })
    },
    isUniqueCode (v) {
      const tt = this.tankTypes.find(item => item.tankTypeCode === v)

      if (tt == null) return true
      if (tt.id === this.tankType.id) return true
      return false
    }
  }
}

const props = ['id', 'tankTypeCode', 'tankName', 'makerName', 'oilMaxVolume', 'tankMaxVolume', 'oilVolumeRate', 'tankWidth', 'tankDepth', 'tankHeight', 'remarks']
</script>
